<template>
  <MainHeader />
  <MainSidebar />
  <div
    class="main-content bg_gray d-flex flex-column transition overflow-hidden"
  >
    <BreadcrumbMenu pageTitle="Print Barcode" />
    <ChooseForm />
    <SelectedProducts />
    <!-- <PaperSize /> -->
    <div class="row gx-0 mb-50">
      <div class="col-md-6 offset-md-6">
        <div
          class="filter-right d-flex align-items-center justify-content-md-end flex-wrap"
        >
          <button type="button" class="btn style-four" @click="resetAll">
            Reset
            <img src="../../assets/img/icons/rotate-left.svg" alt="Image" />
          </button>
          <button class="btn style-one" id="create-barcode" @click="showPreview">
            Create Labels<img
              src="../../assets/img/icons/add-circle.svg"
              alt="Image"
            />
          </button>
          <button
            class="btn style-five upload-btn px-xxl-6"
            @click="printOnly('barcode')"
          >
            Print Barcode<img src="../../assets/img/icons/download.svg" alt="Image" />
          </button>
          <button
            class="btn style-five upload-btn px-xxl-6"
            @click="printOnly('qrcode')"
          >
            Print QR Code<img src="../../assets/img/icons/download.svg" alt="Image" />
          </button>
        </div>
      </div>
    </div>
    <BarcodeWrapper />

    <div class="flex-grow-1"></div>
    <MainFooter />
  </div>
  <div
    class="delete-popup offcanvas offcanvas-end border-0"
    tabindex="-1"
    id="deletePopup"
  >
    <div class="offcanvas-body p-0">
      <div class="delete-success">
        <img src="../../assets/img/icons/tick-circle.svg" alt="Image" />
        <span class="text-white fw-medium">
          Your product is deleted from the list.
        </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Swal from "sweetalert2";
import stateStore from "../../utils/store";

import MainHeader from "../../components/Layouts/MainHeader.vue";
import MainSidebar from "../../components/Layouts/MainSidebar.vue";
import BreadcrumbMenu from "../../components/Common/BreadcrumbMenu.vue";
import ChooseForm from "../../components/Products/PrintBarcode/ChooseForm.vue";
import SelectedProducts from "../../components/Products/PrintBarcode/SelectedProducts.vue";
import BarcodeWrapper from "../../components/Products/PrintBarcode/BarcodeWrapper.vue";
import MainFooter from "../../components/Layouts/MainFooter.vue";

export default defineComponent({
  name: "PrintBarcodePage",
  components: {
    MainHeader,
    MainSidebar,
    BreadcrumbMenu,
    ChooseForm,
    SelectedProducts,
    BarcodeWrapper,
    MainFooter,
  },
  setup() {
    const toggleBarcode = stateStore;

    const ensureProductsSelected = async () => {
      if (stateStore.selectedProducts.length > 0) {
        return true;
      }

      await Swal.fire("No Products", "Please select at least one product to preview or print labels.", "warning");
      return false;
    };

    const showPreview = async () => {
      const hasProducts = await ensureProductsSelected();
      if (!hasProducts) return;
      stateStore.open = true;
    };

    const resetAll = () => {
      stateStore.clearSelectedProducts();
      stateStore.open = false;
    };

    const printOnly = async (type: "barcode" | "qrcode") => {
      const hasProducts = await ensureProductsSelected();
      if (!hasProducts) return;

      stateStore.setPrintType(type);
      stateStore.open = true;
      setTimeout(() => {
        window.print();
      }, 100);
    };

    return {
      stateStore,
      toggleBarcode,
      resetAll,
      showPreview,
      printOnly,
    };
  },
});
</script>

<style lang="scss" scoped>
@media print {
  :global(body) {
    background: #fff !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  :global(body *) {
    visibility: hidden !important;
  }

  :global(.barcode-print-root),
  :global(.barcode-print-root *) {
    visibility: visible !important;
  }

  :global(.barcode-print-root) {
    display: block !important;
    position: fixed !important;
    inset: 0 !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    background: #fff !important;
    border: 0 !important;
    box-shadow: none !important;
    border-radius: 0 !important;
    overflow: visible !important;
    z-index: 999999 !important;
  }

  :global(.barcode-print-root .card-body) {
    padding: 12mm !important;
  }

  :global(.barcode-print-root .control-panel) {
    display: none !important;
  }

  :global(.barcode-print-root .barcode-wrap) {
    margin: 0 !important;
  }

  :global(.barcode-print-root .barcode-item) {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }
}

.filter-right {
  a {
    margin-right: 10px;
    &:last-child {
      margin-right: 0;
    }
  }
  div,
  button {
    margin-right: 10px;
  }
}

@media only screen and (max-width: 767px) {
  .filter-right {
    a,
    div,
    button {
      margin-bottom: 10px;
    }
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .filter-right {
    width: calc(100% + 20px);
    margin-left: -20px;
  }
}

@media only screen and (min-width: 1400px) {
  .filter-right {
    a,
    div,
    button {
      margin-right: 15px;
    }
  }
}
</style>
